import React from 'react';
import VerticalContentCard, { VerticalContentCardProps } from './VerticalContentCard';
import VerticalTextList, { VerticalTextListProps } from './VerticalTextList';

export interface VerticalContentCardWithTextListProps {
  verticalContentCardProps: Omit<VerticalContentCardProps, 'children'>;
  verticalTextListProps: VerticalTextListProps;
}

const VerticalContentCardWithTextList = ({
  verticalContentCardProps,
  verticalTextListProps,
}: VerticalContentCardWithTextListProps): JSX.Element => {
  return (
    <VerticalContentCard {...verticalContentCardProps}>
      <VerticalTextList {...verticalTextListProps} />
    </VerticalContentCard>
  );
};

export default VerticalContentCardWithTextList;
